import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

const toTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

const FooterLink = ({ to, children, className = "site-footer__link" }) =>
  to.startsWith("http") || to === "#" ? (
    <Link onClick={toTop} to={to} className={className}>
      {children}
    </Link>
  ) : (
    <Link onClick={toTop} to={to} className={className}>
      {children}
    </Link>
  );

function Footer() {
  return (
    <footer className="site-footer" role="contentinfo">
      <div className="site-footer__inner">
        <div className="site-footer__columns">
          <nav className="site-footer__col" aria-label="Customer service">
            <h2 className="site-footer__col-title">Customer Service</h2>
            <ul className="site-footer__list">
              <li>
                <FooterLink to="/contact">Help Center</FooterLink>
              </li>

              <li>
                <FooterLink to="/shipping">Shipping</FooterLink>
              </li>
              <li>
                <FooterLink to="/returns">Returns &amp; Exchanges</FooterLink>
              </li>
              <li>
                <FooterLink to="/faqs">FAQs</FooterLink>
              </li>
              <li>
                <FooterLink to="/policies/sizing-fit">
                  Size &amp; Fit
                </FooterLink>
              </li>
              <li>
                <a
                  className="site-footer__link"
                  href="mailto:cost@averlynxstore.one"
                >
                  Customer Care
                </a>
              </li>
            </ul>
          </nav>

          <nav className="site-footer__col" aria-label="Shopping policies">
            <h2 className="site-footer__col-title">Shopping Policies</h2>
            <ul className="site-footer__list">
              <li>
                <FooterLink to="/policies">All Policies</FooterLink>
              </li>
              <li>
                <FooterLink to="/policies/payment-billing">
                  Payment &amp; Billing
                </FooterLink>
              </li>
              <li>
                <FooterLink to="/policies/orders-cancellations">
                  Orders &amp; Cancellations
                </FooterLink>
              </li>
              <li>
                <FooterLink to="/policies/preorders-backorders">
                  Pre-Orders &amp; Backorders
                </FooterLink>
              </li>
              <li>
                <FooterLink to="/policies/promotions-pricing">
                  Promotions &amp; Pricing
                </FooterLink>
              </li>
              <li>
                <FooterLink to="/policies/gift-cards-store-credit">
                  Gift Cards &amp; Store Credit
                </FooterLink>
              </li>
              <li>
                <FooterLink to="/policies/warranty-defects">
                  Warranty &amp; Defects
                </FooterLink>
              </li>
              <li>
                <FooterLink to="/policies/product-safety-recalls">
                  Product Safety &amp; Recalls
                </FooterLink>
              </li>
            </ul>
          </nav>

          <nav
            className="site-footer__col"
            aria-label="Legal and privacy policies"
          >
            <h2 className="site-footer__col-title">Legal &amp; Privacy</h2>
            <ul className="site-footer__list">
              <li>
                <FooterLink to="/terms">Terms &amp; Conditions</FooterLink>
              </li>
              <li>
                <FooterLink to="/privacy">Privacy Policy</FooterLink>
              </li>
              <li>
                <FooterLink to="/cookies">Cookie Policy</FooterLink>
              </li>
              <li>
                <FooterLink to="/policies/regional-privacy">
                  Privacy Rights &amp; Requests
                </FooterLink>
              </li>
              <li>
                <FooterLink to="/policies/intellectual-property">
                  Intellectual Property
                </FooterLink>
              </li>
              <li>
                <FooterLink to="/policies/acceptable-use">
                  Acceptable Use
                </FooterLink>
              </li>
              <li>
                <FooterLink to="/policies/accessibility">
                  Accessibility
                </FooterLink>
              </li>
              <li>
                <FooterLink to="/policies/complaints-disputes">
                  Complaints &amp; Disputes
                </FooterLink>
              </li>
            </ul>
          </nav>

          <div className="site-footer__col">
            <h2 className="site-footer__col-title">Contact</h2>
            <p>
              JianYong Ma
              <br />
              c19890921@sina.com
              <br />
              WanChengZhenWangHaiDaDao
              <br />
              HaiNanYiShengYuan2Dong1DanYuan209Fang
              <br />
              WanNingShi
              <br />
              571500
              <br />
              China
              <br />
              Call us: +86 18469657385
            </p>
          </div>
        </div>

        <div className="site-footer__bottom">
          <div className="site-footer__bottom-left">
            <div className="site-footer__meta-row">
              <p className="site-footer__copyright">
                © 2026 averlynxstore. All Rights Reserved.
              </p>
            </div>
          </div>
          <button
            type="button"
            className="site-footer__to-top"
            onClick={toTop}
            aria-label="Back to top"
          >
            ↑
          </button>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
